import React from "react";
import PropTypes from "prop-types";

function FileUpload({ accept, multiple = false, onChange, className = "" }) {
  const handleChange = (e) => {
    const files = e.target.files;
    if (!files) return;

    if (multiple) {
      onChange(Array.from(files));
    } else {
      onChange(files[0]);
    }
  };

  return (
    <div className={`relative ${className}`}>
      <input
        type="file"
        accept={accept}
        multiple={multiple}
        onChange={handleChange}
        className="block w-full text-sm text-slate-500
          file-4 file-2 file-4
          file-full file-0
          file-sm file-semibold
          file-violet-50 file-violet-700
          hover-violet-100"
      />
    </div>
  );
}

FileUpload.propTypes = {
  accept: PropTypes.string,
  multiple: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default FileUpload;
